import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=019aaa2a&scoped=true"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"
import style0 from "./PricingCard.vue?vue&type=style&index=0&id=019aaa2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019aaa2a",
  null
  
)

export default component.exports